import { render } from "./QIReport.vue?vue&type=template&id=97b8816a"
import script from "./QIReport.vue?vue&type=script&lang=js"
export * from "./QIReport.vue?vue&type=script&lang=js"

import "./QIReport.vue?vue&type=style&index=0&id=97b8816a&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__